
Vivense.init['cartProductList'] = Vivense.init['cartProductList'] || [];

window.viveCartProductList = window.viveCartProductList || {};

Vivense.init['cartProductList'].push(function() {
    var $ = jQuery;
    var bulk_products = [];
    var not_bulk_products = [];
    var living_products = [];


// send order details such as product_note, bulk products, forward delivery products, showroom location for showroom users
    window.viveCartProductList.orderDetails = function() {
        var pushData = {};
        var url = [];
        var note = '';
        var delivery = '';
        var showroomSelected = '';
        var product = '';
        var product_notes = $('.product-note-textarea');
        var deliveryStatusCheckbox = $('.delivery-chooses-checkbox-1');
        var productStatusCheckbox = $('.delivery-chooses-checkbox-2');
        var isShowroomSaleCheckbox = $('.stock-sale-checkbox');
        var showroom_list = $('#showroom_list');
        var bulkProducts = $(".bulk_product");
        var defaultBulkDate = $('#bulk_date_default');
        var bulkDate = $('#bulk_date');
        var bulkOrderDate = $('.not_bulk_date_default');
        var forwardDeliveryDate = $('.forward_delivery_checkbox');
        var forwardDeliveryCheck = $(".forward_delivery_chck");
        var showroom_location = 0;
        var delivery_date = '';



        if (showroom_list != null && showroom_list.length > 0) {
            showroom_location = parseInt(showroom_list.val());
            pushData["showroom_location"] = showroom_location;
        }

        pushData["forward_delivery"] = forwardDeliveryCheck.is(':checked');
        product_notes.each(function () {
            note = $(this);
                pushData["product_note_"+note.data('key')] = note.val();
        });

        var addedDeliveryStatus = [];
        deliveryStatusCheckbox.each(function () {
            delivery = $(this);
            var type = null;
            var delivery_key = delivery.data('key');

            if(delivery.prop('checked')){
                addedDeliveryStatus.push(delivery_key);
                type = $(this).val();
            }

            if(addedDeliveryStatus.includes(delivery_key) && type) {
                pushData["delivery_option_" +delivery_key] = type;
            }

        });


        productStatusCheckbox.each(function () {
            product = $(this);
            var type = null;
            var product_key = product.data('key');

            if(product.prop('checked')){
                type = $(this).val();
            }

            if(!!type) {
                pushData["product_option_" +product_key] = type;
            }

        });

        var addedShowroomSale = [];
        isShowroomSaleCheckbox.each(function () {
            showroomSelected = $(this);

            var isShowroomSale = false;
            var showroom_key = showroomSelected.data('key');

            if(showroomSelected.prop('checked')){
                isShowroomSale = true;
            }

            if(!addedShowroomSale.includes(showroom_key)) {
                addedShowroomSale.push(showroom_key);
                pushData["is_showroom_sale_" + showroomSelected.data('key')] = isShowroomSale;
            }
        });




        pushData["products_are_bulk"] = $(".bulk_order").is(':checked');
        if ($(".bulk_order").is(':checked')) {
            bulkProducts.each(function () {
                product = $(this);
                var pkey = product.data('pkey');
                if (product.hasClass('checkedBulk')) {
                    delivery_date = bulkDate.val() ? bulkDate.val() : defaultBulkDate.val();
                    delivery_date = delivery_date ? delivery_date : null;
                    pushData["product_delivery_date_" + pkey] = delivery_date;
                    pushData["is_bulk_" + pkey] = true;
                    pushData["is_forward_" + pkey] = (delivery_date != null);
                }
                else {
                    bulkOrderDate.each(function () {
                        if (pkey == $(this).data('pkey')) {
                            delivery_date = $(this).val() ? $(this).val() : $('.default_bulk_date[data-pkey="' + pkey + '"]').val();
                            pushData["product_delivery_date_" + pkey] = delivery_date;
                            pushData["is_bulk_" + pkey] = false;
                            pushData["is_forward_" + pkey] = ($(this).closest('tr').find('.not_bulk_checkbox').is(':checked'));
                        }
                    });
                }
            });
        }
        else {
            var isForwardDeliveryChecked = forwardDeliveryCheck.is(':checked');
            forwardDeliveryDate.each(function () {
                product = $(this);
                var pkey = product.data('pkey');
                if (isForwardDeliveryChecked) {
                    delivery_date = product.closest('tr').find('.productDate').val() ? product.closest('tr').find('.productDate').val() : null;
                    pushData["product_delivery_date_" + pkey] = delivery_date;
                    pushData["is_bulk_" + pkey] = false;
                    pushData["is_forward_" + pkey] = product.is(':checked');
                } else {
                    pushData["product_delivery_date_" + pkey] = null;
                    pushData["is_bulk_" + pkey] = false;
                    pushData["is_forward_" + pkey] = false;
                }
            });
        }

        console.log(pushData);

        $.ajax('/index.php?option=com_virtuemart&nosef=1&view=cart&task=orderDetails', {
            method: 'POST',
            async: false,
            data: pushData
        })
            .done(function (data) {
                console.log(data);
            })
            .fail();

    };


// if product count in shopping cart falls below two products, bulk order checked is removed
    function controlBulk() {

        var checkedProducts = $(".checkedBulk");
        var bulkProducts = $(".bulk_product");
        var bulkOrderCheck = $(".bulk_order");

        if (checkedProducts.length < 2 && bulkOrderCheck.is(':checked')) {
            bulkOrderCheck.prop("checked", false);
            $("#bulk_product_div").css("display", "none");
            $("#bulk_delivery_div").css('display', 'none');

            if ($(".forward_delivery_chck").is(':checked')) {
                $("#forward_delivery_div").css('display', 'block');
            }

            bulkProducts.each(function () {
                var product = $(this);
                if (product.data('living') == 0) {
                    product.prop('checked', false);
                    product.removeClass("checkedBulk");
                }
            });
        }
    }


// returning a date this format: 2017-02-14
    function organizeDateFormat(date) {

        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();

        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }

        return year + '-' + month + '-' + day;
    }


// if the product exists in an array, it returns true, otherwise it returns false
    function isExistingProduct(product, array) {

        for (var i = 0; i < array.length; i++) {
            if (product == array[i]) {
                return true;
            }
        }

        return false;
    }


// when the product remove from shopping cart, related elements of this product are removed
    window.viveCartProductList.removeProduct = function(product_key){

        var product_note = $('.product-note-textarea');
        var not_bulk_product = $('.not_bulk_checkbox');
        var forward_delivery_product = $('.forward_delivery_checkbox');
        var bulkProducts = $(".bulk_product");
        var bulkOrderSelection = $('#bulk_order_selection_div');
        var bulkProductDiv = $('#bulk_product_div');
        var bulkOrderCheck = $('.bulk_order');
        var forwardDeliveryCheck = $(".forward_delivery_chck");
        var product_count = 0;

        product_note.each(function () {
            if ($(this).data('operationtype') == 'cargo') {
                product_count++;
            }
        });

        product_note.each(function () {
            if ($(this).data('key') == product_key) {

                $(this).closest(".product-request-and-note").remove();
            }
        });
        forward_delivery_product.each(function () {
            if ($(this).data('pkey') == product_key) {
                $(this).closest("tr").remove();
            }
        });
        bulkProducts.each(function () {
            if ($(this).data('pkey') == product_key) {
                $(this).closest("div").remove();
                if (isExistingProduct($(this).data('sku'), bulk_products)) {
                    bulk_products.splice(parseInt(bulk_products.indexOf($(this).data('sku'))), 1);
                }
            }
        });
        not_bulk_product.each(function () {
            if ($(this).data('pkey') == product_key) {
                $(this).closest("tr").remove();
                if (isExistingProduct($(this).data('sku'), not_bulk_products)) {
                    not_bulk_products.splice(parseInt(not_bulk_products.indexOf($(this).data('sku'))), 1);
                }
            }
        });

        if ($('.product-note-textarea').length <= 1) {
            bulkOrderSelection.css('display', 'none');
            bulkProductDiv.css('display', 'none');
        }

        changeBulkProduct(false);
    };


// if product is not bulk, display this product as separated
    function changeNotBulkProduct() {

        var new_not_bulk_row = '';
        var default_delivery_date = $(".forward_delivery_checkbox");
        var bulkProducts = $(".bulk_product");
        var pkey_products = [];
        var deadline = new Date();

        bulkProducts.each(function () {
            if (!$(this).hasClass('checkedBulk') && !window.viveCartProductList.isTheOperationTypeCargo( $(this).data('operationtype'))) {
                pkey_products.push($(this).data('pkey'));
            }
        });



        for (var i = 0; i < pkey_products.length; i++) {
            default_delivery_date.each(function () {
                if ($(this).data('pkey') == pkey_products[i]) {

                    var maxDeadLineMonth = 1;
                    if($(".bulk_order").length > 0){
                        maxDeadLineMonth = $(".bulk_order").data("max-month-diff");
                    }
                    deadline = new Date($(this).data('date'))
                    deadline.setMonth(deadline.getMonth() + maxDeadLineMonth);
                    deadline = organizeDateFormat(deadline);

                    if($(this).data('living') == 0){
                        new_not_bulk_row += "<tr id='not_bulk_row'><td width='2%'></td><td width='38%'><input id='bulk_checkbox_" + $(this).data('pkey') + "' class='not_bulk_checkbox operation_type' data-pkey='" + $(this).data('pkey') + "' data-operationtype='" + $(this).data('operationtype') + "' type='checkbox'><label for='bulk_checkbox_" + $(this).data('pkey') + "'>" + $(this).data('sku') + "</label></td><td width='37%'> <input class='default_bulk_date' data-pkey='" + $(this).data('pkey') + "' type='hidden' value='" + $(this).data('date') + "'>" + $(this).data('date') + "</td><td width='32%'><input class='form-control col-md-2 bulkDate not_bulk_date_default' data-pkey='" + $(this).data('pkey') + "' style='width: 150px;' onkeypress='return event.charCode < 48 || event.charCode > 57' disabled type='date' min='" + $(this).data('date') + "' max='" + deadline + "'></td></tr>";
                    }
                    else{
                        new_not_bulk_row += "<tr id='not_bulk_row'><td width='2%'></td><td width='38%'><input id='bulk_checkbox_" + $(this).data('pkey') + "' class='not_bulk_checkbox operation_type' data-pkey='" + $(this).data('pkey') + "' data-operationtype='" + $(this).data('operationtype') + "' type='checkbox' disabled><label for='bulk_checkbox_" + $(this).data('pkey') + "'>" + $(this).data('sku') + "</label></td><td width='37%'> <input class='default_bulk_date' data-pkey='" + $(this).data('pkey') + "' type='hidden' value='" + $(this).data('date') + "'>" + $(this).data('date') + "</td><td width='32%'><input class='form-control col-md-2 bulkDate not_bulk_date_default' data-pkey='" + $(this).data('pkey') + "' style='width: 150px;' onkeypress='return event.charCode < 48 || event.charCode > 57' disabled type='date' min='" + $(this).data('date') + "' max='" + deadline + "'></td></tr>";
                    }
                }
            });
        }

        $('#forward_delivery_table').append(new_not_bulk_row);
    }


// when the product changes bulk property, shopping cart is updated
    function changeBulkProduct(is_add_product) {
        if ($(".bulk_product").length < 2) {
            $(".bulk_order").prop("checked", false);
            $(".bulk_product").removeClass("checkedBulk");
            $("#bulk_delivery_div").css('display', 'none');
            $("#bulk_product_div").css('display', 'none');
            return;
        }

        var bulkOrderRow = $("#bulk_order_row");
        var checkedProducts = $(".checkedBulk");
        var checkedProductDate = $('.forward_delivery_checkbox');
        var bulkProducts = $(".bulk_product");
        var new_bulk_row = '';
        var pkey;
        var bulk_products_index = -1;
        var not_bulk_products_index = -1;
        var max_date = new Date();
        var deadline = new Date();
        var products = '';
        var flag = true;
        var bulkDeliveryDiv = $('#bulk_delivery_div');
        var forwardDeliveryDiv = $('#forward_delivery_div');
        var bulkOrderDiv = $("#bulk_product_div");
        var operation_type = $('.forward_delivery_checkbox');

        max_date = organizeDateFormat(max_date);

        bulkOrderRow.remove();

        $('[id="not_bulk_row"]').remove();

        bulk_products = [];
        not_bulk_products = [];

        checkedProducts.each(function () {
            pkey = $(this).data('pkey');
            bulk_products.push($(this).data('sku'));

            checkedProductDate.each(function () {
                if (pkey == $(this).data('pkey')) {
                    if ($(this).data('date') > max_date) {
                        max_date = $(this).data('date');
                    }
                }
            });

            if(!is_add_product && $(this).attr("data-operationtype")){
                if(!window.viveCartProductList.isTheOperationTypeManufacturerCargo($(this).attr("data-operationtype"))){
                    flag = false;
                }
            }
        });

        bulkProducts.each(function () {
            if (!$(this).hasClass('checkedBulk')) {
                not_bulk_products.push($(this).data('sku'));
            }
        });

        if (!is_add_product && flag && $("input[name='bulk_order_check']").is(":checked")) {

            $("input[name='bulk_order_check']").prop("checked", false);

            checkedProducts.each(function () {
                $(this).prop("checked", false);
            });

            bulkOrderDiv.css("display", "none");
            bulkDeliveryDiv.css('display', 'none');
            forwardDeliveryDiv.css('display', 'block');

            operation_type.each(function () {
                if(window.viveCartProductList.isTheOperationTypeManufacturerCargo($(this).data('operationtype'))){
                    $(this).prop("disabled", true);
                }
            });
        }

        max_date = new Date(max_date);
        var deadline_max_date = new Date(max_date);
        var maxDeadLineMonth = 1;
        if($(".bulk_order").length > 0){
            maxDeadLineMonth = $(".bulk_order").data("max-month-diff");
        }

        if (bulk_products.length < 2) {
            products = bulk_products.join();
            deadline.setMonth(deadline.getMonth() + maxDeadLineMonth);
        }
        else {
            products = 'Toplu(' + bulk_products.join() + ')';

            deadline = new Date(deadline_max_date.setMonth(deadline_max_date.getMonth()+maxDeadLineMonth));
        }
        deadline = organizeDateFormat(deadline);
        max_date = organizeDateFormat(max_date);

        new_bulk_row = "<tr id='bulk_order_row'>" +
            "<td width='2%'></td><td width='38.5%'><input id='bulk_checkbox' class='not_bulk_checkbox' type='checkbox'> <label for='bulk_checkbox'>" + products + "</label></td><td width='36%'> <input id='bulk_date_default' type='hidden' value='" + max_date + "'> " + max_date + "</td><td width='0%'><input class='form-control bulkDate bulk_order_date' id='bulk_date' style='width: 150px;' onkeypress='return event.charCode < 48 || event.charCode > 57' disabled type='date' min='" + max_date + "' max='" + deadline + "'></td></tr>";

        $('#forward_delivery_table tr:last').after(new_bulk_row);

        if (not_bulk_products.length > 0) {
            changeNotBulkProduct();
        }

        var not_bulk_checkbox = $(".not_bulk_checkbox");

        not_bulk_checkbox.each(function () {
            if($(this).attr("data-operationtype")){
                if(window.viveCartProductList.isTheOperationTypeCargo($(this).attr('data-operationtype'))){
                    $(this).prop("disabled", true);
                }
            }
        });
    }

    window.viveCartProductList.calculateMargin = function(){
        var coupon_input = $('#coupon_code');

        var calculate_margin = $('#calculate_margin');


        var totalPrice = parseInt(calculate_margin.attr('data-totalprice'));
        var totalEffectiveCogs = parseInt(calculate_margin.attr('data-totaleffectivecogs'));
        var total_discount = parseInt(calculate_margin.attr('data-discount'));

        if (total_discount && total_discount != 0) {
            if (totalEffectiveCogs != 0 && totalPrice != 0) {
                $('#coupon_div').css('display', 'none');
            }

            var margin = 0;
            var discount = 0;

            margin = 1 - (totalEffectiveCogs / totalPrice);
            discount = total_discount / totalPrice;

            $('#margin_label').text((margin * 100).toFixed(1));
            $('#coupon_label').text((discount * 100).toFixed(1));
            $('#margin_coupon_label').text(((margin - discount) * 100).toFixed(1));
        }
        else {
            $('#coupon_div').css('display', 'none');
        }
    };


    $('#calculate_discount_margin_button').bind("click",function () {
        var calculate_margin = $('#calculate_margin');
        var totalPrice = parseInt(calculate_margin.attr('data-totalprice'));
        var new_amount = parseInt($('#calculate_discount_margin').val());
        calculate_margin.val(totalPrice - new_amount);
        window.viveCartProductList.calculateNewMargin();
    });


// calculate margin
    $('#calculate_margin_button').bind("click",function(){

        window.viveCartProductList.calculateNewMargin();
    });

    window.viveCartProductList.isTheOperationTypeManufacturerCargo = function(operationType){
        return operationType.toLowerCase().includes("üretici kargo/nakliyat");

    }


    window.viveCartProductList.isTheOperationTypeCargo = function(operationType){
        return operationType.toLowerCase().includes("kargo");

    }

    window.viveCartProductList.calculateNewMargin = function(){
        var calculate_margin = $('#calculate_margin');
        var calculateDiv = $('#calculate_div');
        var discount = parseInt(calculate_margin.val());
        var totalPrice = parseInt(calculate_margin.attr('data-totalprice'));
        var totalEffectiveCogs = parseInt(calculate_margin.attr('data-totaleffectivecogs'));
        var new_discount = discount/totalPrice;
        var margin = 1 - (totalEffectiveCogs / totalPrice);


        if (discount && totalPrice >= discount) {

            calculate_margin.css('border-color', 'transparent');
            calculateDiv.css('display', 'none');
            $('#new_margin_label').text((margin * 100).toFixed(1));
            $('#new_coupon_label').text((new_discount * 100).toFixed(1));
            $('#new_margin_coupon_label').text(((margin - new_discount) * 100).toFixed(1));
            $('#new_total_price').text((totalPrice - discount).toFixed(0));

        }
        else {
            calculate_margin.val('');
            calculateDiv.css('display', 'none');
        }
    };


    window.viveCartProductList.bindAdminEvents = function(){
        // Bulk Delivery
        $(".bulk_order").on('click', function () {
            var bulkOrderRow = $("#bulk_order_row");
            var bulkProducts = $(".bulk_product");
            var bulkOrderDiv = $("#bulk_product_div");
            var forwardDeliveryCheck = $(".forward_delivery_chck");
            var bulkDeliveryDiv = $('#bulk_delivery_div');
            var forwardDeliveryDiv = $('#forward_delivery_div');
            var operation_type = $('.forward_delivery_checkbox');

            bulk_products = [];
            not_bulk_products = [];
            living_products = [];

            bulkProducts.each(function () {
                bulk_products.push($(this).data('sku'));
                if($(this).data('living') == 1){
                    living_products.push($(this).data('pkey'));
                }
            });

            if ($(this).is(':checked') && !forwardDeliveryCheck.is(':checked')) {


                bulkOrderDiv.css("display", "flex");

                bulkDeliveryDiv.css('display', 'none');
                forwardDeliveryDiv.css('display', 'none');
                bulkProducts.each(function () {
                    var product = $(this);
                    if(product.data('living') == 0 && (bulk_products.length - living_products.length) > 1
                        && !window.viveCartProductList.isTheOperationTypeManufacturerCargo(product.data('operationtype'))) {
                        product.prop('checked', true);
                        product.addClass("checkedBulk");
                    }
                });
            }
            else if ($(this).is(':checked') && forwardDeliveryCheck.is(':checked')) {
                bulkOrderDiv.css("display", "flex");
                bulkDeliveryDiv.css('display', 'flex');
                forwardDeliveryDiv.css('display', 'none');
                bulkProducts.each(function () {
                    var product = $(this);
                    if(product.data('living') == 0 && !window.viveCartProductList.isTheOperationTypeManufacturerCargo(product.data('operationtype'))){
                        product.prop('checked', true);
                        product.addClass("checkedBulk");
                    }
                });
            }
            else if (!$(this).is(':checked') && forwardDeliveryCheck.is(':checked')) {
                bulkOrderDiv.css("display", "none");
                bulkDeliveryDiv.css('display', 'none');
                forwardDeliveryDiv.css('display', 'block');
                bulkProducts.each(function () {
                    var product = $(this);
                    if(product.data('living') == 0) {
                        product.prop('checked', false);
                        product.removeClass("checkedBulk");
                    }
                });
                operation_type.each(function () {
                    if(window.viveCartProductList.isTheOperationTypeManufacturerCargo($(this).data('operationtype'))){
                        $(this).prop("disabled", true);
                    }
                });
            }
            else if (!$(this).is(':checked') && !forwardDeliveryCheck.is(':checked')) {
                bulkOrderDiv.css("display", "none");
                bulkDeliveryDiv.css('display', 'none');
                forwardDeliveryDiv.css('display', 'none');
                bulkProducts.each(function () {
                    var product = $(this);
                    if(product.data('living') == 0) {
                        product.prop('checked', false);
                        product.removeClass("checkedBulk");
                    }
                });
            }

            if((bulk_products.length - living_products.length) < 2){
                $('.bulk_order').click();
            }

            changeBulkProduct(true);

            window.viveCartProductList.orderDetails();
            window.viveCartProductList.getPartial();
        });


// list bulk products
        $(".bulk_product").on('click', function () {
            var product = $(this);

            if (product.is(':checked') && !window.viveCartProductList.isTheOperationTypeManufacturerCargo(product.data('operationtype'))) {
                product.addClass("checkedBulk");
            }
            else {
                product.removeClass("checkedBulk");
            }

            var checkedProducts = $(".checkedBulk");
            if (checkedProducts.length >= 2) {
                changeBulkProduct(true);
            } else {
                changeBulkProduct(false);
            }

            controlBulk();
            window.viveCartProductList.orderDetails();
            window.viveCartProductList.getPartial();
        });


        // when only forward delivery selection is checked and the product checkbox is clicked, its forward delivery date is enable or disable
        $(".forward_delivery_checkbox").on('click', function () {

            var product = $(this);
            var dateInput = product.closest("tr").find('.productDate');

            if (product.is(':checked')) {
                dateInput.prop('disabled', false);
            }
            else {
                dateInput.val('');
                dateInput.prop('disabled', true);
            }

        });


        // Forward Delivery
        $(".forward_delivery_chck").on('click', function () {

            var forwardDeliveryDiv = $('#forward_delivery_div');
            var products = $('.forward_delivery_checkbox');
            var bulkOrderCheck = $('.bulk_order');
            var bulkDeliveryDiv = $('#bulk_delivery_div');
            var operation_type = $('.forward_delivery_checkbox');

            if ($(this).is(':checked') && !bulkOrderCheck.is(':checked')) {
                bulkDeliveryDiv.css('display', 'none');
                forwardDeliveryDiv.css('display', 'flex');
                operation_type.each(function () {
                    if(window.viveCartProductList.isTheOperationTypeManufacturerCargo($(this).data('operationtype'))){
                        $(this).prop("disabled", true);
                    }
                });
            }
            else if ($(this).is(':checked') && bulkOrderCheck.is(':checked')) {
                forwardDeliveryDiv.css('display', 'none');
                bulkDeliveryDiv.css('display', 'flex');
                $('#forward_delivery_table').css('display', 'block');
            }
            else if (!$(this).is(':checked')) {
                bulkDeliveryDiv.css('display', 'none');
                forwardDeliveryDiv.css('display', 'none');

                products.each(function () {
                    var product = $(this);
                    product.prop('checked', false);
                    var dateInput = product.closest('tr').find(".productDate");
                    dateInput.val('');
                    dateInput.prop('disabled', true);
                });
            }
        });


        // when bulk order and forward delivery selection are checked together and the product checkbox is clicked, its forward delivery date is enable or disable
        $(document).on('click', '.not_bulk_checkbox', function (e) {

            var product = $(this);
            var dateInput = product.closest("tr").find('.bulkDate');

            if (product.is(':checked')) {
                dateInput.prop('disabled', false);
            }
            else {
                dateInput.val('');
                dateInput.prop('disabled', true);
            }
        });
    };

    window.viveCartProductList.bindAdminEvents();




});